/* eslint-disable max-len */
import React from 'react';

type TagOutlineProps = {
  width?: number;
  height?: number;
  color?: string;
};

export function TagOutline({ width = 48, height = 48, color = '#000000', ...props }: TagOutlineProps): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 48 48' fill='none' {...props}>
      <title>Tag Outline</title>
      <path
        d='M28.2285 36.7501C32.3366 35.9242 35.6443 32.5764 36.4714 28.3619C37.2986 32.5764 40.6053 35.9242 44.7135 36.7501M44.7135 36.7548C40.6053 37.5806 37.2978 40.9285 36.4706 45.1429C35.6435 40.9285 32.3366 37.5806 28.2285 36.7548'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M40.7767 26.1643L41.9197 25.0213C42.993 23.9481 43.5926 22.4905 43.5854 20.9727L43.5304 9.28854C43.5158 6.16838 40.99 3.64261 37.8699 3.62788L26.1855 3.5727C24.6677 3.56551 23.2101 4.16528 22.1369 5.23849L3.93475 23.4409C2.45403 24.9216 2.45404 27.3223 3.93477 28.8031L18.3554 43.2236C19.8361 44.7044 22.2368 44.7044 23.7177 43.2236L25.6224 41.3188'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.153 10.0042C36.8713 9.7224 36.3077 9.72239 36.0257 10.0042C35.744 10.286 35.744 10.8496 36.0257 11.1314'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.1554 10.0026C37.4373 10.2844 37.4373 10.848 37.1554 11.1298C36.8737 11.4116 36.31 11.4116 36.0283 11.1298'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
